import { render } from "./PolicyRuleTarget.vue?vue&type=template&id=4f4c2155&scoped=true"
import script from "./PolicyRuleTarget.vue?vue&type=script&lang=js"
export * from "./PolicyRuleTarget.vue?vue&type=script&lang=js"

import "./PolicyRuleTarget.vue?vue&type=style&index=0&id=4f4c2155&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4c2155"]])

export default __exports__